import { Routes as RRDRoutes, Route as RRDRoute } from 'react-router-dom'
import React from 'react'
import { routes } from './routes'
import { Routes } from './types'
export function Navigation() {
    const makeRoutes = (routes: Routes) =>
        routes.map(({ routes, path, element, errorElement }, i) => {
            if (routes && routes.length) {
                return (
                    <RRDRoute
                        key={`route-${i}`}
                        path={path}
                        element={element}
                        errorElement={errorElement}
                    >
                        {makeRoutes(routes)}
                    </RRDRoute>
                )
            }

            return (
                <RRDRoute
                    key={`route-${i}`}
                    path={path}
                    element={element}
                    errorElement={errorElement}
                />
            )
        })
    return <RRDRoutes>{makeRoutes(routes)}</RRDRoutes>
}
